import { App as AntdApp, ConfigProvider } from "antd";
import { Suspense } from "react";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import { BounceLoader } from "react-spinners";
import { PersistGate } from "redux-persist/integration/react";

import useDropdownTouchFix from "./hooks/useDropdownTouchFix";
import Routers from "./routes";
import { persistor, store } from "./store";

import "./styles/index.scss";

const LoadingScreen = () => (
  <div className="loading-screen">
    <BounceLoader color="#004AAD" />
  </div>
);

function App() {
  // タブレットでのドロップダウンスクロール問題を修正
  useDropdownTouchFix();

  return (
    <Provider store={store}>
      <Sentry.ErrorBoundary
        fallback={<p>エラーが発生しました。ページを再読み込みしてください。</p>}
      >
        <ConfigProvider
          theme={{
            token: {
              fontFamily: "BIZ UDPGothic",
            },
          }}
        >
          <AntdApp message={{ duration: 10 }}>
            <PersistGate loading={<LoadingScreen />} persistor={persistor}>
              <Suspense fallback={<LoadingScreen />}>
                <Routers />
              </Suspense>
            </PersistGate>
          </AntdApp>
        </ConfigProvider>
      </Sentry.ErrorBoundary>
    </Provider>
  );
}

export default App;
